// Matches date-only strings in ISO 8601 format: YYYY-MM-DD
export const dateOnlyPattern = /^\d{4}-\d{2}-\d{2}$/;
